import { ExternalLink, FileText, Play, Volume2 } from "lucide-react";

const getIconComponent = (iconName: string) => {
  switch (iconName) {
    case "Play":
      return Play;
    case "Volume2":
      return Volume2;
    case "FileText":
      return FileText;
    case "ExternalLink":
    default:
      return ExternalLink;
  }
};

interface LinkIconProps {
  iconName: string;
  data?: string;
  className?: string;
  onError?: () => void;
}

export const LinkIcon = ({
  iconName,
  data,
  className = "h-6 w-6 text-gray-600",
  onError,
}: LinkIconProps) => {
  const IconComponent = getIconComponent(iconName);

  if (iconName === "Image" && data) {
    return (
      <img
        src={data}
        className="h-12 w-12 rounded object-cover"
        alt="link preview"
        onError={onError}
      />
    );
  }

  return <IconComponent className={className} />;
};
